import script from "./nav.vue?vue&type=script&setup=true&lang=js"
export * from "./nav.vue?vue&type=script&setup=true&lang=js"

import "./nav.vue?vue&type=style&index=0&id=04f17b10&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f17b10"]])

export default __exports__